import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const PushMower = createSvgIcon(
  <path d="M1.455 1.454A4.966 4.966 0 0 1 4.966 0H7.5v2.25H4.966c-.72 0-1.411.286-1.92.795l-.113.113a2.331 2.331 0 0 0 .113 3.403l5.359 4.689h1.117l.978.26V6.403l8.566 2.336A2.625 2.625 0 0 1 21 11.271v3.04l.75.2v2.931A3.377 3.377 0 0 1 20.625 24c-1.47 0-2.72-.94-3.183-2.25H7.188a3.75 3.75 0 1 1-4.938-4.938V11.25h2.738L1.564 8.254a4.581 4.581 0 0 1-.222-6.687l.113-.113ZM19.5 17.442v-1.203L9.228 13.5H4.5v3.075A3.755 3.755 0 0 1 7.425 19.5h10.017a3.385 3.385 0 0 1 2.058-2.058Zm-.75-3.731v-2.44a.375.375 0 0 0-.276-.362L12.75 9.348v2.763l6 1.6Z" />,
  'PushMower'
);

export { PushMower };